import React, { useState } from "react";
import { PageHeader, Row, Col, Button, Select, DatePicker } from "antd";

import ModalNewMeeting from "./ModalNewMeeting";

const Header = ({ setQuarterly, setMeetingDate, setLoadData, meetingDates, setMeetingYear, quarterly, meetingDate }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const handleDateChange = (date, dateString) => {
        if (!dateString) return;

        const explodeString = dateString.split("-");
        const year = explodeString[0];
        const quarter = explodeString[1].slice(-1);

        setQuarterly(quarter);
        setMeetingYear(year);
    };

    const handleMeetingDateChange = (value) => {
        if (!value) return;

        setMeetingDate(value);
    };

    return (
        <>
            <PageHeader
                className="m-page-header"
                style={{ paddingBottom: "20px" }}
                onBack={null}
                title={
                    <div style={{ fontSize: "18px" }}>
                        Tablero de objetivos {quarterly === "1" ? "1er trimestre" : quarterly === "2" ? "2do trimestre" : quarterly === "3" ? "3er trimestre" : quarterly === "4" ? "4to trimestre" : ""} | Grupo Optima{" "} | {meetingDate
                            ? new Date(`${meetingDate}T00:00:00`).toLocaleDateString("es-MX", {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                            })
                            : ""}
                    </div>
                }
                subTitle={null}
                extra={[
                    <Row span={24} gutter={8} key="1" style={{ margin: "0 20px" }}>
                        <Col span={8}>
                            <DatePicker onChange={handleDateChange} picker="quarter" />
                        </Col>
                        <Col span={8}>
                            <Select
                                defaultValue="Seleccione una fecha"
                                style={{ width: 120 }}
                                allowClear
                                options={meetingDates}
                                placeholder="Fecha"
                                onChange={handleMeetingDateChange}
                            />
                        </Col>
                        <Col span={8}>
                            <Button type="primary" onClick={showModal}>Crear nueva reunion</Button>
                        </Col>
                    </Row>
                ]}
            />

            <ModalNewMeeting isModalOpen={isModalOpen} onOk={handleOk} onCancel={handleCancel} setQuarterly={setQuarterly} setMeetingDate={setMeetingDate} setLoadData={setLoadData} />
        </>
    )
}

export default Header